import { alpha, createTheme } from "@mui/material";
import { Colors } from "../assets";

const theme = createTheme({
  palette: {
    primary: {
      main: "#151D30",
    },
    secondary: {
      main: "#1A1824",
    },
    info: {
      main: "#0090B7",
    },
    success: {
      main: "#00C9A5",
      dark: "#151D30",
    },
    error: {
      main: "#E3597A",
    },
    warning: {
      main: "#F9F871",
    },
  },
  typography: {
    fontFamily: "'Urbanist', sans-serif",
  },
  components: {
    MuiSwitch: {
      defaultProps: {
        color: "primary",
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          width: 46,
          height: 26,
          padding: "0 !important",
          overflow: "hidden",
          position: "relative",
          borderRadius: 13,
          backgroundColor: Colors.white,
          boxSizing: "border-box",
        },
        switchBase: ({ theme: muiTheme }) => ({
          padding: 3,
          top: 0,
          left: 0,
          width: 26,
          height: 26,
          zIndex: 2,
          backgroundColor: "transparent !important",
          transition: muiTheme.transitions.create(["transform"], {
            duration: 250,
            easing: "cubic-bezier(0.4, 0, 0.2, 1)",
          }),
          "&:hover, &.Mui-focusVisible, &:active": {
            backgroundColor: "transparent !important",
          },
          "&.Mui-checked": {
            transform: "translateX(20px)",
            color: Colors.white,
            backgroundColor: "transparent !important",
            "&:hover, &.Mui-focusVisible, &:active": {
              backgroundColor: "transparent !important",
            },
            "& + .MuiSwitch-track": {
              opacity: 1,
              backgroundColor: "transparent",
              background: `linear-gradient(135deg, ${muiTheme.palette.primary.main} 0%, ${muiTheme.palette.secondary.main} 100%)`,
              boxShadow: `0 2px 8px ${alpha(muiTheme.palette.primary.main, 0.35)}`,
            },
          },
          "&:not(.Mui-checked):hover:not(.Mui-disabled) + .MuiSwitch-track": {
            backgroundColor: "#C8CCD4",
          },
          "&.Mui-checked:hover:not(.Mui-disabled) + .MuiSwitch-track": {
            background: `linear-gradient(135deg, ${muiTheme.palette.secondary.main} 0%, ${muiTheme.palette.primary.main} 100%)`,
          },
          "&.Mui-disabled": {
            "& + .MuiSwitch-track": {
              opacity: 0.45,
            },
            "& .MuiSwitch-thumb": {
              opacity: 0.85,
            },
          },
        }),
        thumb: {
          width: 20,
          height: 20,
          backgroundColor: Colors.white,
          boxShadow:
            "0 1px 4px rgba(21, 29, 48, 0.18), 0 0 1px rgba(21, 29, 48, 0.08)",
        },
        track: ({ theme: muiTheme }) => ({
          position: "absolute",
          inset: 0,
          zIndex: 1,
          borderRadius: 13,
          opacity: 1,
          backgroundColor: "#E2E4E9",
          transition: muiTheme.transitions.create(
            ["background-color", "background", "box-shadow"],
            { duration: 250, easing: "cubic-bezier(0.4, 0, 0.2, 1)" }
          ),
        }),
        sizeSmall: {
          width: 38,
          height: 22,
          padding: "0 !important",
          borderRadius: 11,
          backgroundColor: Colors.white,
          "& .MuiSwitch-switchBase": {
            padding: 2,
            width: 22,
            height: 22,
            "&.Mui-checked": {
              transform: "translateX(16px)",
            },
          },
          "& .MuiSwitch-thumb": {
            width: 18,
            height: 18,
            boxShadow: "0 1px 3px rgba(21, 29, 48, 0.2)",
          },
          "& .MuiSwitch-track": {
            borderRadius: 11,
          },
        },
      },
    },
  },
});
export default theme;
